const zh = {
  i18nView: {
    login: '登录',
    account: '账号',
    home: '首页',
    appIntro: '使用说明',
    backgroundIntro: '背景介绍:',
    back1: '本合约(DApp)是为了存储基于EOS账号的基础信息，为方便区块链浏览器，钱包，DApp以及用户更好的了解某个账号的信息和用途。',
    back2: '为了使更多的用户可以关注了解到这个信息的意义，我们设计了一个FOMO的玩法。鼓励大家尽早的去编辑自己的信息。',
    rule: '规则:',
    rule1: '1.任何人可以为任意账号编辑基础信息。',
    rule2: '2.账号编辑初始价格为0.1 EOS, 每次修改价格为上一次价格的1.5倍，其中1.4倍返回给上一个修改者，剩下留在合约中为后续合约升级使用。',
    rule3: '3.如果一个账号已经被修改过，当账号所有者去更新该账号时，需要支付上一个修改价格的一半，这些EOS返回给上个修改者。',
    rule4: '4.当一个账号被该账号所有者编辑后，其他人则不可以再修改该账号的信息。',
    personalInfo: '个人信息',
    nickname: '昵称',
    lastModifier: '最后编辑者',
    searchList: '搜索列表',
    intrestList: '可能感兴趣的账号',
    lastPrice: '上次修改价格',
    empty: '暂无',
    noSuchAccount: '没有这个账号',
    edit: '编辑',
    locked: '本信息由本人编辑，已经锁定',
    avatar: '头像',
    enterIntro: '请输入简介',
    website: '网站',
    wechatId: '微信ID',
    confirmEdit: '确认编辑',
    shortLocked: '已锁定',
    cost: '花费',
    intro: '简介',
    success: '修改成功',
    mine: '我参与的',
    interested: '感兴趣的',
    searchAccount: '搜索EOS账号',
    recently: '最新',
    supportList: '支持列表',
    inviteIntro: '邀请说明',
    inviteTips: '只有当你的账号已经本人编辑过后，邀请链接才会生效',
    inviteTips1: '当被邀请人编辑任何一个初始状态的账号时, 会将其一半的费用给邀请人, 即0.05 EOS',
    inviteTips2: '当被邀请人编辑一个非本人且非初始状态的账号时，会给予邀请人5%于上一个修改价格的EOS',
    copy: '复制',
    viewInBrowser: '在区块链浏览器中查看'

  }
};

export default zh;